import Vue from 'vue';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}
import App from '../../App.vue';
import router from '../rooters/support';
import store from '../stores/support';
import globalConfig from '@utiles/globalConfig';

import setCommonPlugins from '../../resource/configs/setGlobalCommonPlugins';
import clickThrottling from '../../resource/plugins/clickThrottling';
import '@plugins/replaceAllPolyfills';

// 设置点击节流.
Vue.use(clickThrottling);
clickThrottling.setThrottlingTime(800);
Vue.config.productionTip = true;

globalConfig.setVuePrototypePlatformConfig(Vue);
Vue.prototype.$isSupport = true;

setCommonPlugins(Vue);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#support');
